import React from 'react';
import { WordCloud } from '@ant-design/plots';
import styles from "../../../assets/styles/modules/Newsinfo.module.css";

const WordCloudChart = ({relatedCorp}) => {
    const data = relatedCorp && relatedCorp.map(corp => {return ({...corp, stockcode: Number(corp.stockcode)})})
    const config = {
        data,
        wordField: 'stockname',
        weightField: 'stockcode',
        colorField: 'stockname',
        wordStyle: {fontSize: [18, 32],},
        tooltip: false,
        random: () => 0.5,
    };

    return(
        <div className={styles.related_container}>
            <p className='title_md'>해당 이슈를 공유하는 기업들</p>
            <WordCloud {...config} height={200}/>
        </div>
      );
};

export default WordCloudChart;